import {graphql, useFragment} from 'react-relay'

import type {PipelineLineLastRunFragment$key} from './__generated__/PipelineLineLastRunFragment.graphql'

const fragment = graphql`
  fragment PipelineLineLastRunFragment on ProjectRest {
    buildTypes {
      buildType {
        builds(locator: "count:1,state:any") {
          build {
            rawId
            state
            startEstimate
            finishDate
            ...RunStatusFragment
            ...useRunningBuildUpdaterRelayFragment
          }
        }
      }
    }
  }
`

export function useLastRun(projectKey: PipelineLineLastRunFragment$key | null) {
  const project = useFragment(fragment, projectKey)
  return project?.buildTypes?.buildType?.[0]?.builds?.build?.[0] ?? null
}
